import AccountCircle from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { HEADER_USER_NAME_MAX_WIDTH } from './header.constants';

const userNameSx: SxProps<Theme> = {
  display: { xs: 'none', sm: 'block' },
  marginInlineStart: 1,
  maxWidth: HEADER_USER_NAME_MAX_WIDTH,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

interface ProfileMenuButtonProps {
  menuId: string;
  expanded: boolean;
  userName: string;
  onOpen: (anchor: HTMLElement) => void;
}

export const ProfileMenuButton = ({ menuId, expanded, userName, onOpen }: ProfileMenuButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <IconButton
      edge="end"
      color="inherit"
      aria-label={t('profile.accountAria', 'account of current user')}
      aria-haspopup="menu"
      aria-expanded={expanded}
      aria-controls={expanded ? menuId : undefined}
      onClick={(event) => onOpen(event.currentTarget)}
    >
      <AccountCircle />
      {userName && (
        <Typography variant="body2" sx={userNameSx}>
          {userName}
        </Typography>
      )}
    </IconButton>
  );
};
